<div class="container-fluid pt-2 compact-dashboard">

  <!-- Layout principal en dos columnas -->
  <div class="row h-100">
    <!-- Columna izquierda: Información del dispositivo, estado, contadores y parámetros -->
    <div class="col-lg-6 col-md-12 d-flex flex-column h-100">

      <!-- Información del Dispositivo -->
      <div class="row ">
        <div class="col-12">
          <div class="card">
            <div class="card-header py-2">
              <h6 class="card-title mb-0">
                Estado general del Dispositivo
              </h6>
            </div>
            <div class="card-body ">
              <div class="row ">
                <div class="col-12">
                  <div class="d-flex flex-row gap-3 justify-content-around align-items-stretch">

                    <div class="data-item">
                      <div class="data-icon mx-auto mb-2 bg-primary bg-opacity-10"
                        [ngClass]="data.alive ? 'bg-success ' : 'bg-danger '">
                        <i class="fa-solid fa-wifi" [ngClass]="data.alive ? 'text-success' : 'text-danger'"></i>
                      </div>
                      <div class="data-content text-center">
                        <div class="data-value"></div>
                        <!-- <small class="data-label">Conexión</small> -->
                      </div>
                    </div>

                    <div class="data-item">
                      <div class="data-icon bg-warning bg-opacity-10 mx-auto mb-2"
                        [ngClass]="data.alarms.state ? 'bg-primary ' : 'bg-danger '">
                        <i class="fa-solid fa-triangle-exclamation"
                          [ngClass]="data.alarms.state ? 'text-danger' : 'text-muted'"></i>
                      </div>
                      <div class="data-content text-center">
                        <div class="data-value"></div>
                        <small class="data-label">{{ data.alarms.state && data.alarms.overcurrent ? 'Sobreintensidad' :
                          '' }}</small>
                      </div>
                    </div>


                    <div class="data-item">
                      <div class="data-icon bg-primary bg-opacity-10 mx-auto mb-2">
                        <i class="fas fa-clock text-primary"></i>
                      </div>
                      <div class="data-content text-center">
                        <div class="data-value">325h</div>
                        <small class="data-label">Totales</small>
                      </div>
                    </div>
                    <div class="data-item">
                      <div class="data-icon bg-warning bg-opacity-10 mx-auto mb-2">
                        <i class="fas fa-clock text-warning"></i>
                      </div>
                      <div class="data-content text-center">
                        <div class="data-value">125h</div>
                        <small class="data-label">Parciales</small>
                      </div>
                    </div>


                                        <div class="data-item">
                      <div class="data-icon bg-warning bg-opacity-10 mx-auto mb-2">
                        <i class="fas fa-temperature-high text-danger"></i>
                      </div>
                      <div class="data-content text-center">
                        <div class="data-value">{{data.temperature_C}}°C</div>
                        <!-- <small class="data-label">Temperatura</small> -->
                      </div>
                    </div>


                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Parámetros Instantáneos, Contadores y Estado en una fila -->
      <div class="row ">
        <div class="col-12">
          <div class="card">
            <div class="card-header py-2">
              <div class="d-flex align-items-center justify-content-between">
                <h6 class="card-title mb-0">{{ isSlaveSelected() ? 'Parámetros Eléctricos Monofásicos' : 'Parámetros Eléctricos Trifásicos' }}</h6>
                <div class="d-flex align-items-center gap-2">
                  <button class="btn btn-sm btn-link px-2"
                    (click)="previousOption()"
                    [disabled]="option === 1">
                    <i class="fas fa-chevron-left"></i>
                  </button>
                  <span class="text-secondary small">
                    {{ getOptionLabel() }}
                  </span>
                  <button class="btn btn-sm btn-link px-2"
                    (click)="nextOption()"
                    [disabled]="option === getMaxOption()">
                    <i class="fas fa-chevron-right"></i>
                  </button>
                </div>
              </div>
            </div>
            <div class="card-body py-2">
              <!-- Cabecera de fases - Solo para trifásicos -->
              <div *ngIf="!isSlaveSelected()" class="d-flex justify-content-end">
                  <div class="d-flex mb-0 me-2 pe-3" style="gap: 8px;">
                    <div class="text-brown fw-semibold" style="min-width: 80px; text-align: center;">L1</div>
                    <div class="text-dark fw-semibold" style="min-width: 80px; text-align: center;">L2</div>
                    <div class="text-muted fw-semibold" style="min-width: 80px; text-align: center;">L3</div>
                    <div class="text-dark fw-semibold" style="min-width: 80px; text-align: center;">Total</div>
                  </div>
              </div>

              <!-- Voltaje -->
              <div class="d-flex align-items-center px-3 py-2">
                <div class="param-icon icon-voltage">
                  <i class="fas fa-bolt"></i>
                </div>
                <div class="fw-medium text-dark fs-6" style="min-width: 80px;">Voltaje (V)</div>
                <div class="d-flex gap-2 flex-fill justify-content-end">
                  <!-- Monofásico (esclavo) -->
                  <div *ngIf="isSlaveSelected()" class="d-flex justify-content-end">
                    <div class="badge bg-primary text-white py-2 px-3 rounded fw-semibold fs-6 text-center" style="min-width: 80px; ">{{selectedParams?.perPhase[0]?.voltage_V | number:'1.1-1'}}</div>
                  </div>
                  <!-- Trifásico (analizadores) -->
                  <div *ngIf="!isSlaveSelected()" class="d-flex" style="gap: 8px;">
                    <div class="badge bg-white text-dark py-1 px-2 rounded fw-semibold text-center fs-6 border" style="min-width: 80px;  border: 1px solid #834100 !important; border-left: 5px solid #834100 !important;">{{selectedParams?.perPhase[0]?.voltage_V | number:'1.1-1'}}</div>
                    <div class="badge bg-white text-dark py-1 px-2 rounded fw-semibold text-center fs-6 border" style="min-width: 80px;  border: 1px solid #050505 !important; border-left: 5px solid #050505 !important;">{{selectedParams?.perPhase[1]?.voltage_V | number:'1.1-1'}}</div>
                    <div class="badge bg-white text-dark py-1 px-2 rounded fw-semibold text-center fs-6 border" style="min-width: 80px;  border: 1px solid #979797 !important; border-left: 5px solid #979797 !important;">{{selectedParams?.perPhase[2]?.voltage_V | number:'1.1-1'}}</div>
                    <div class="badge bg-primary text-white py-1 px-2 rounded fw-semibold text-center fs-6" style="min-width: 80px; ">{{selectedParams?.totals?.avgVoltage_V | number:'1.1-1'}}</div>
                  </div>
                </div>
              </div>


              <!-- Corriente -->
              <div class="d-flex align-items-center px-3 py-2">
                <div class="param-icon icon-current">
                  <i class="fas fa-tachometer-alt"></i>
                </div>
                <div class="fw-medium text-dark fs-6" style="min-width: 80px;">Intensidad (A)</div>
                <div class="d-flex gap-2 flex-fill justify-content-end">
                  <!-- Monofásico (esclavo) -->
                  <div *ngIf="isSlaveSelected()" class="d-flex justify-content-end">
                    <div class="badge bg-primary text-white py-2 px-2 rounded fw-semibold text-center fs-6" style="min-width: 80px;">{{selectedParams?.perPhase[0]?.current_A | number:'1.1-1'}}</div>
                  </div>
                  <!-- Trifásico (analizadores) -->
                  <div *ngIf="!isSlaveSelected()" class="d-flex" style="gap: 8px;">
                    <div class="badge bg-white text-dark py-1 px-2 rounded fw-semibold text-center fs-6 border border-gray" style="min-width: 80px; border: 1px solid #834100 !important; border-left: 5px solid #834100 !important;">{{selectedParams?.perPhase[0]?.current_A | number:'1.1-1'}}</div>
                    <div class="badge bg-white text-dark py-1 px-2 rounded fw-semibold text-center fs-6 border border-gray" style="min-width: 80px; border: 1px solid #050505 !important; border-left: 5px solid #050505 !important;">{{selectedParams?.perPhase[1]?.current_A | number:'1.1-1'}}</div>
                    <div class="badge bg-white text-dark py-1 px-2 rounded fw-semibold text-center fs-6 border border-gray" style="min-width: 80px; border: 1px solid #979797 !important; border-left: 5px solid #979797 !important;">{{selectedParams?.perPhase[2]?.current_A | number:'1.1-1'}}</div>
                    <div class="badge bg-primary text-white py-1 px-2 rounded fw-semibold text-center fs-6" style="min-width: 80px; ">{{selectedParams?.totals?.avgCurrent_A * 3 | number:'1.1-1'}}</div>
                  </div>
                </div>
              </div>


              <!-- Potencia -->
              <div class="d-flex align-items-center px-3 py-2">
                <div class="param-icon icon-power">
                  <i class="fas fa-plug"></i>
                </div>
                <div class="fw-medium text-dark fs-6" style="min-width: 80px;">Potencia (W)</div>
                <div class="d-flex gap-2 flex-fill justify-content-end">
                  <!-- Monofásico (esclavo) -->
                  <div *ngIf="isSlaveSelected()" class="d-flex justify-content-end">
                    <div class="badge bg-primary text-white py-2 px-2 rounded fw-semibold text-center fs-6" style="min-width: 80px; font-size: 20px;">{{selectedParams?.perPhase[0]?.activePower_W | number:'1.1-1'}}</div>
                  </div>
                  <!-- Trifásico (analizadores) -->
                  <div *ngIf="!isSlaveSelected()" class="d-flex" style="gap: 8px;">
                    <div class="badge bg-white text-dark py-1 px-2 rounded fw-semibold text-center fs-6 border border-gray" style="min-width: 80px; font-size: 20px; border: 1px solid #834100 !important; border-left: 5px solid #834100 !important;">{{selectedParams?.perPhase[0]?.activePower_W | number:'1.1-1'}}
                    </div>
                    <div class="badge bg-white text-dark py-1 px-2 rounded fw-semibold text-center fs-6 border border-gray" style="min-width: 80px; border: 1px solid #050505 !important; border-left: 5px solid #050505 !important;">{{selectedParams?.perPhase[1]?.activePower_W | number:'1.1-1'}}
                    </div>
                    <div class="badge bg-white text-dark py-1 px-2 rounded fw-semibold text-center fs-6 border border-gray" style="min-width: 80px; ; border: 1px solid #979797 !important; border-left: 5px solid #979797 !important;">{{selectedParams?.perPhase[2]?.activePower_W | number:'1.1-1'}}
                    </div>
                    <div class="badge bg-dark text-white py-1 px-2 rounded fw-semibold text-center fs-6" style="min-width: 80px; ">{{selectedParams?.totals?.totalActivePower_W | number:'1.1-1'}}</div>
                  </div>
                </div>
              </div>

                <!-- Título con línea horizontal -->
                <div class="d-flex align-items-center mb-2 px-2">
                  <span class="text-secondary small me-2" style="white-space:nowrap;">Energía Activa Consumida</span>
                  <hr class="flex-grow-1 border-secondary border-1 m-0" />
                </div>
                <!-- Contadores de energía estilo compacto -->
                <div class="mb-2">
                  <div class="row g-2">
                    <!-- Total -->
                    <div class="col-6">
                      <div class="bg-light border rounded-3 d-flex flex-column align-items-center justify-content-center p-2">
                        <i class="fas fa-bolt text-warning mb-1" style="font-size: 1rem;"></i>
                        <div class="fs-6 fw-bold text-dark">
                          {{selectedParams?.totals?.totalEnergy_kWh/1000 | number:'1.1-1'}}
                          <span class="small fw-normal">MWh</span>
                        </div>
                        <small class="text-muted" style="font-size: 0.7rem;">Total</small>
                      </div>
                    </div>
                    <!-- Parcial -->
                    <div class="col-6">
                      <div class="bg-light border rounded-3 d-flex flex-column align-items-center justify-content-center p-2">
                        <i class="fas fa-bolt text-warning mb-1" style="font-size: 1rem;"></i>
                        <div class="fs-6 fw-bold text-dark">
                          {{selectedParams?.totals?.partialEnergy_kWh | number:'1.1-1'}}
                          <span class="small fw-normal">kWh</span>
                        </div>
                        <small class="text-muted" style="font-size: 0.7rem;">Parcial</small>
                      </div>
                    </div>
                  </div>
                </div>
            </div>
          </div>
        </div>
      </div>


      <!-- Estado de Salidas  -->
      <div class="row ">
        <div class="col-12">
          <div class="card">
            <div class="card-header py-2">
              <h6 class="card-title mb-0 ">Estado de Salidas</h6>
            </div>
            <div class="card-body p-3">
              <div class="row gx-2 gy-2">
                <ng-container *ngFor="let key of outputKeys; let i = index">
                  <div class="col-3">
                    <div class="bg-light border rounded-3 h-100 d-flex flex-column justify-content-between p-3">
                      <div class="d-flex align-items-center justify-content-between mb-1">
                        <span class="fw-semibold text-dark me-2">Salida {{i + 1}}</span>
                        <div class="form-check form-switch mb-0">
                          <input class="form-check-input" type="checkbox" role="switch" [checked]="data.outputs[key]"
                            (change)="toggleOutput(key)" style="cursor: pointer;">
                        </div>
                      </div>
                      <div class="d-flex justify-content-center align-items-center flex-grow-1">
                      </div>
                    </div>
                  </div>
                </ng-container>

                <!-- Separador XeoSwitch -->
                <!-- <div class="col-12 d-flex align-items-center mt-2 px-4">
                  <span class="text-secondary small me-2" style="white-space:nowrap;">XeoSwitch</span>
                  <hr class="flex-grow-1 border-secondary border-1 m-0" />
                </div> -->

                <!-- Salidas de esclavos debajo del separador -->
                <ng-container *ngFor="let slave of data.slaves; let i = index">
                  <div class="col-6">
                    <div class="border rounded-3 h-100 d-flex flex-column justify-content-between p-3 bg-light">
                      <div class="d-flex align-items-center justify-content-between mb-1">
                        <span class="fw-semibold text-dark me-2 d-flex align-items-center">
                          <i class="fa-solid fa-wifi me-2" [ngClass]="slave.online ? 'text-success' : 'text-danger'" style="font-size:1em;"></i>
                          {{slave.model}} {{slave.address}}
                        </span>
                        <div class="form-check form-switch mb-0">
                          <input class="form-check-input"
                                 type="checkbox"
                                 role="switch"
                                 [checked]="slave.outState"
                                 (change)="toggleOutputSlave(i)"
                                 style="cursor: pointer;">
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>


      <!-- Estado de Entradas  -->
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-header py-2">
              <h6 class="card-title mb-0 ">Estado de Entradas</h6>
            </div>
            <div class="card-body p-2">

                <div class="d-flex flex-row flex-wrap gap-3 justify-content-center">
                  <ng-container *ngFor="let input of data.inputs">
                    <div class="d-flex flex-column align-items-center justify-content-between px-0 py-2 rounded-3  "
                         style="min-width: 60px; min-height: 80px;">

                      <input
                        [placeholder]="input.name"
                        class="mb-1 fw-semibold small text-dark text-center"
                        style="font-size: 0.75rem; letter-spacing: 0.5px; padding:0; margin:0; border: none; background: transparent; outline: none; min-width:  40px;"
                        [(ngModel)]="input.name"
                      />


                      <span class="mb-1 rounded-circle d-block"
                        [ngClass]="input.state ? 'bg-success' : 'bg-secondary'"
                        style="width: 14px; height: 14px;"></span>
                      <span class="fw-bold small text-center"
                            [ngClass]="input.state ? 'text-success' : 'text-secondary'"
                            style="font-size: 0.75rem;">
                        {{input.state ? 'ON' : 'OFF'}}
                      </span>
                    </div>
                  </ng-container>
                </div>
            </div>
          </div>
        </div>
      </div>




    </div>

    <!-- Columna derecha: Gráfico de programación -->
    <div class="col-lg-6 col-md-12 d-flex flex-column h-100">

      <div class="card flex-fill">
        <div class="card-header py-2">
          <div class="d-flex justify-content-between align-items-center">
            <h6 class="card-title mb-0 small">
              Programación Semanal
            </h6>
            <app-out-buttons [numOutputs]="getTotalOutputs()" [slaves]="data.slaves" (outputChange)="onOutputChange($event)"></app-out-buttons>
            <button type="button" class="btn btn-sm border text-secondary bg-transparent rounded-pill"
              style="border-width:1px;" title="Editar programación" (click)="openSchedulerModal()">
              <i class="fas fa-edit me-1"></i>Editar
            </button>
          </div>
        </div>
        <div class="card-body py-2 flex-fill">
          <!-- Componente de programación reutilizable -->
          <ng-container *ngIf="!hideSchedulerAnc">
          <app-scheduler-anc
            [schedulerData]="getSchedulerData()"
            [chartIdPrefix]="'chart'"
            [selectedOutput]="selectedOutput"
            [sunTimesData]="sunTimesData"
            [outputCount]="getTotalOutputs()">
          </app-scheduler-anc>
          </ng-container>
        </div>
      </div>

    </div>
  </div>
</div>
